export const getScheduledHolidayMetadatas = /* GraphQL */ `
  query GetScheduledHolidayMetadatas(
    $tenantLandscape: String
    $nextToken: String
  ) {
    scheduledHolidayMetadatas: scheduledHolidayMetadatasByTenantLandscape(
      tenantLandscape: $tenantLandscape
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        rruleSet
        labels
      }
      nextToken
    }
  }
`;

export const scheduledHolidayMetadataLabelsByTenantLandscape = /* GraphQL */ `
  query ScheduledHolidayMetadatasByTenantLandscape(
    $tenantLandscape: String
    $nextToken: String
  ) {
    scheduledHolidayMetadatasByTenantLandscape(
      tenantLandscape: $tenantLandscape
      nextToken: $nextToken
    ) {
      items {
        labels
      }
      nextToken
    }
  }
`;
